import React from 'react';

const Spinner = (_args: any) => <div />;

export default Spinner;
